import { render, staticRenderFns } from "./NewsHtml.vue?vue&type=template&id=2174cd48&scoped=true"
import script from "./NewsHtml.vue?vue&type=script&lang=js"
export * from "./NewsHtml.vue?vue&type=script&lang=js"
import style0 from "./NewsHtml.vue?vue&type=style&index=0&id=2174cd48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2174cd48",
  null
  
)

export default component.exports